import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategoryGrid() {
  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 bg-primary-100 text-primary-800 text-xs font-medium rounded-full mb-4">
            分类浏览
          </span>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            热门<strong className="text-primary-600">资讯分类</strong>
          </h2>
          <p className="text-sm text-foreground-600 max-w-lg mx-auto">
            涵盖娱乐八卦、社会热点、网络吃瓜等多个领域，选择你感兴趣的分类，浏览最新最全的资讯内容。
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.id}
              to={`/category/${cat.slug}`}
              className="bg-background-100 rounded-lg p-4 md:p-5 border border-background-200/70 hover:border-primary-300/50 hover:bg-background-50 transition-all duration-300 group cursor-pointer"
            >
              <div className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center bg-primary-100 rounded-lg mb-3 group-hover:bg-primary-200 transition-colors">
                <i className={`${cat.icon} text-lg md:text-xl text-primary-600`}></i>
              </div>
              <h3 className="text-sm md:text-base font-heading font-semibold text-foreground-900 mb-1 whitespace-nowrap">
                {cat.name}
              </h3>
              <p className="text-xs text-foreground-500 leading-relaxed mb-2 line-clamp-2">
                {cat.description}
              </p>
              <span className="text-xs text-foreground-400">
                {cat.articleCount} 篇文章
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}